import noUiSlider from "nouislider";
import PerfectScrollbar from "perfect-scrollbar";
import jQuery from "jquery";
import "jquery-deserialize";
import "./lib/formatUnicorn";
import "./lib/tableSorter";

(function ($) {
    $.fn.preload = (image) => ($("<img/>")[0].src = image);

    const $filter_overlay = $(".filter-overlay");
    const $filter_overlay_btn = $("[data-overlay]");
    const $filter_overlay_btn_close = $("[data-overlay-close]");

    document.querySelectorAll('[id^="range-ui-"]').forEach((range_ui) => {
        let options = JSON.parse(range_ui.getAttribute("data-range-slider"));

        const instance = noUiSlider.create(range_ui, {
            ...options,
            format: {
                to: function (value) {
                    return `${value}${options.unit}`;
                },
                from: function (value) {
                    return Number(value.replace(`${options.unit}`, ""));
                },
            },
            cssClasses: {
                ...noUiSlider.cssClasses,
                ...options.cssClasses,
            },
        });

        let input = document.querySelector(range_ui.getAttribute("data-input"));

        instance.on("update", (values) => {
            input.value = `${Number(values[0].replace(`${options.unit}`, ""))},${Number(values[1].replace(`${options.unit}`, ""))}`;
        });

        instance.on("end", () => {
            $(".apartment-filter-form").submit();
        });
    });

    const close_overlay = () => {
        $filter_overlay.slideUp();
        $filter_overlay_btn.removeClass("active");
        const $filters_available = $filter_overlay_btn.parents(".apartments-filters-available");
        $filters_available.removeAttr("data-filter-pane-open");
        $filters_available.next().find("form").trigger("submit");
    };

    $(document).on("click", function (event) {
        if ($filter_overlay.is(":visible") && $(event.target).closest(".filter-overlay").length === 0) {
            close_overlay();
        }
    });

    $filter_overlay_btn_close.on("click", function (event) {
        close_overlay();
    });

    $filter_overlay_btn.on("click", function () {
        if ($(this).hasClass("active")) {
            $(".filter-overlay#" + $(this).data("overlay")).slideUp(400);
            $(this).toggleClass("active");
            $(this).parents(".apartments-filters-available").removeAttr("data-filter-pane-open");
        } else {
            $filter_overlay.slideUp(400, () => {
                $("[data-overlay]").not($(this)).removeClass("active");
                setTimeout(() => {
                    $(this).addClass("active");
                    $(".filter-overlay#" + $(this).data("overlay")).slideDown(400);
                    $(this)
                        .parents(".apartments-filters-available")
                        .attr("data-filter-pane-open", $(this).data("overlay"));
                }, 100);
            });
        }
    });

    $("#apartment-list").each(function () {
        const $container = $(this);
        const $active_filters = $container.find(".apartments-filters-active > .active-filters");
        const $available_filters = $container.find(".apartments-filters-available");
        const $apartment_location = $container.find(".apartments-location-image");
        const $results_container = $container.find(".apartments-results");
        const $results = $results_container.find("table tbody tr");
        const $table_container = $results_container.find(".table-custom");
        const $show_more = $container.find("#show-more");
        const $status = $container.find('input[name="status"]');
        let ps = null;

        var init_ps = () => {
            ps = new PerfectScrollbar($table_container[0], {
                wheelPropagation: false,
                suppressScrollX: true,
            });

            $table_container.on("ps-y-reach-end", () => {
                $results_container.addClass("remove-shadow");
            });
        };

        let debounce_match_media;
        const media = matchMedia("not all and (min-width: 1024px)");

        if (!media.matches) {
            init_ps();
        }

        media.addEventListener("change", (event) => {
            clearTimeout(debounce_match_media);
            debounce_match_media = setTimeout(() => {
                if (event.matches) {
                    if (ps !== null) {
                        ps.destroy();
                    }
                    ps = null;
                } else if (ps === null) {
                    init_ps();
                } else {
                    ps.update();
                }
            });
        });

        // Preload apartment images into cache
        // Prevents flickering when hovering over an apartment to show its image
        var apartmentObserver = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    console.log("preloading", entry.target.getAttribute("data-image"));
                    $().preload(entry.target.getAttribute("data-image"));
                    observer.unobserve(entry.target);
                });
            },
            {
                root: $results_container.find("table")[0],
            },
        );

        // Display apartment location on hover
        $results.toArray().forEach((apartment) => apartmentObserver.observe(apartment));
        $results.on("mouseenter", function () {
            $apartment_location.css("background-image", "url(" + $(this).data("image") + ")");
        });
        $results.on("mouseleave", function () {
            $apartment_location.css("background-image", "");
        });

        $show_more.on("click", function () {
            $show_more.toggleClass("d-none");
            $results_container.toggleClass("limit-results");
        });

        /**
         * Supported filters: (must be an object, keys correspond to the data-* attributes)
         * - Exact value
         * - Range (object with 'from' and 'to' keys)
         * @param filters
         */
        $.fn.applyFilter = function (filters = {}) {
            this.each(function () {
                let all_filters_match = true;

                Object.keys(filters).forEach((filter_attr) => {
                    let match = false;

                    const filter = filters[filter_attr];

                    if (!Array.isArray(filter) && typeof filter === "object") {
                        if (filter.from && filter.to) {
                            if ($(this).data(filter_attr) >= filter.from && $(this).data(filter_attr) <= filter.to) {
                                match = true;
                            }
                        }
                    } else if (Array.isArray(filter) && filter.length === 1 && filter[0] === "") {
                        match = true;
                    } else if (Array.isArray(filter)) {
                        filter.forEach((val) => {
                            if (val.toString() === $(this).data(filter_attr).toString()) {
                                match = true;
                            }
                        });
                    } else {
                        if (filter.toString() === $(this).data(filter_attr).toString()) {
                            match = true;
                        }
                    }

                    if (!match) {
                        all_filters_match = false;
                    }
                });

                all_filters_match ? $(this).fadeIn() : $(this).fadeOut();
            });

            setTimeout(() => {
                ps.update();
            }, 500);

            return this;
        };

        $.fn.canClearFilter = function () {
            $(this).on("click", function () {
                const value = $(this).data("filter-clear-value");

                if (value) {
                    $('input[name="' + $(this).data("filter-clear-name") + '[]"][value="' + value + '"]').prop(
                        "checked",
                        false,
                    );
                } else {
                    $('input[name="' + $(this).data("filter-clear-name") + '"]').val("");
                }

                $(".apartment-filter-form").submit();
                $(this).remove();
            });
            return this;
        };

        $(".apartment-filter-form").on("submit", function (event) {
            event.preventDefault();

            const form = $(this).serializeArray();
            const filters = {};

            console.log("form", form);

            $active_filters.empty();

            form.forEach((filter) => {
                if (filter.value.indexOf(",") !== -1 && filter.name.indexOf("[]") === -1) {
                    // it's a range
                    filters[filter.name] = {
                        from: parseInt(filter.value.split(",")[0]),
                        to: parseInt(filter.value.split(",")[1]),
                    };

                    const label_template = $filter_overlay.siblings("#overlay-" + filter.name).data("active-label");
                    const label = label_template.formatUnicorn(filters[filter.name].from, filters[filter.name].to);

                    $active_filters.append(
                        $(
                            `<button class="btn-clear-filter px-1 py-0.5 bg-primary/10 rounded-sm cursor-pointer" data-filter-clear-name="${filter.name}"></button>`,
                        )
                            .html(
                                `<div class="flex items-center gap-1"><span>${label}</span><i class="fa-regular fa-times"></i></div>`,
                            )
                            .canClearFilter(),
                    );
                } else if (filter.name.indexOf("[]") !== -1) {
                    filter.name = filter.name.replace("[]", "");
                    if (!filters[filter.name]) {
                        filters[filter.name] = [];
                    }

                    filters[filter.name].push(filter.value);

                    const label_template = $filter_overlay.siblings("#overlay-" + filter.name).data("active-label");
                    const label = label_template.formatUnicorn(filter.value);

                    $active_filters.append(
                        $(
                            `<button class="btn-clear-filter px-1 py-0.5 bg-primary/10 rounded-sm cursor-pointer" data-filter-clear-name="${filter.name}" data-filter-clear-value="${filter.value}"></button>`,
                        )
                            .html(
                                `<div class="flex items-center gap-1"><span>${label}</span><i class="fa-regular fa-times"></i></div>`,
                            )
                            .canClearFilter(),
                    );
                } else {
                    if (!filters[filter.name]) {
                        filters[filter.name] = [];
                    }

                    filters[filter.name].push(filter.value);
                }
            });
            sessionStorage.setItem("filters", JSON.stringify(form));

            $results.applyFilter(filters);

            $show_more.toggleClass("d-none");
            if ($show_more.parent().is(":visible")) {
                $results_container.toggleClass("limit-results");
            }
        });

        if (sessionStorage.getItem("filters")) {
            const filters = JSON.parse(sessionStorage.getItem("filters"));
            if (typeof filters === "object") {
                $(".apartment-filter-form").deserialize(filters).submit();
            }
        }

        $status.on("input", function () {
            $(".apartment-filter-form").trigger("submit");
        });

        $("input[type='checkbox']").on("change", () => {
            $(".apartment-filter-form").submit();
        });
    });
})(jQuery);
